import { GLoading } from 'components/basic-blocks'
import { useUrlQuery } from 'hooks'
import { useEffect } from 'react'
import { AdAccountLinks } from 'services/user/ad-account-links'

export function BingOAuthPage() {
	const query = useUrlQuery()

	useEffect(() => {
		;(async () => {
			const token = query.code
			const reAuth = window.localStorage.getItem('bing-reauth')
			if (reAuth) {
				const accountId = window.localStorage.getItem('account-id')
				const linkId = window.localStorage.getItem('link-id')

				await AdAccountLinks.createOAuthLink('bing', { auth_code: token }, accountId)

				if (linkId && accountId) await AdAccountLinks.syncLink(accountId, linkId)

				window.localStorage.removeItem('account-id')
				window.localStorage.removeItem('bing-reauth')
				window.localStorage.removeItem('link-id')
			}
			window.localStorage.setItem('bing_oauth_code', token)
			if (window && window.opener)
				window.opener.dispatchEvent(new Event('beforeunload'))
			window.close()
		})()
	}, [])

	return (
		<div className="w-full h-full flex items-center justify-center">
			<GLoading />
		</div>
	)
}
